
import { defineComponent, PropType } from '@vue/runtime-core';
import { armorOptions } from '../options';

export default defineComponent({
  name: 'ArmorSelect',
  props: {
    type: {
      type: String as PropType<TArmorType>,
    },
  },
  data() {
    return {
      armorOptions,
    };
  },
});
